import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * Feature flag info schema
 */
export const FeatureFlagInfoSchema = z.object({
  flag: z.string(),
  isActiveInPostHog: z.boolean(),
  enabled: z.boolean(),
  overridden: z.boolean(),
  variantKey: z.string().optional(),
  payload: z.unknown().optional(),
});

/**
 * List feature flags request schema
 */
export const ListFeatureFlagsRequestSchema = z.object({});

/**
 * List feature flags response schema
 */
export const ListFeatureFlagsResponseSchema = z.object({
  flags: z.array(FeatureFlagInfoSchema),
});

/**
 * Set feature flag override request schema
 */
export const SetFeatureFlagOverrideRequestSchema = z.object({
  flag: z.string(),
  enabled: z.boolean().optional(),
  variantKey: z.string().optional(),
  payload: z.unknown().optional(),
});

/**
 * Set feature flag override response schema
 */
export const SetFeatureFlagOverrideResponseSchema = z.object({
  success: z.boolean(),
});

/**
 * Remove feature flag override request schema
 */
export const RemoveFeatureFlagOverrideRequestSchema = z.object({
  flag: z.string(),
});

/**
 * Remove feature flag override response schema
 */
export const RemoveFeatureFlagOverrideResponseSchema = z.object({
  success: z.boolean(),
});

/**
 * Clear all feature flag overrides request schema
 */
export const ClearAllFeatureFlagOverridesRequestSchema = z.object({});

/**
 * Clear all feature flag overrides response schema
 */
export const ClearAllFeatureFlagOverridesResponseSchema = z.object({
  success: z.boolean(),
});

/**
 * List feature flags contract
 */
export const listFeatureFlagsContract = oc
  .input(ListFeatureFlagsRequestSchema)
  .output(ListFeatureFlagsResponseSchema)
  .route({
    method: "GET",
  });

/**
 * Set feature flag override contract
 */
export const setFeatureFlagOverrideContract = oc
  .input(SetFeatureFlagOverrideRequestSchema)
  .output(SetFeatureFlagOverrideResponseSchema)
  .route({
    method: "POST",
  });

/**
 * Remove feature flag override contract
 */
export const removeFeatureFlagOverrideContract = oc
  .input(RemoveFeatureFlagOverrideRequestSchema)
  .output(RemoveFeatureFlagOverrideResponseSchema)
  .route({
    method: "POST",
  });

/**
 * Clear all feature flag overrides contract
 */
export const clearAllFeatureFlagOverridesContract = oc
  .input(ClearAllFeatureFlagOverridesRequestSchema)
  .output(ClearAllFeatureFlagOverridesResponseSchema)
  .route({
    method: "POST",
  });

/**
 * Feature flags contracts
 */
export const featureFlagsContracts = {
  list: listFeatureFlagsContract,
  set: setFeatureFlagOverrideContract,
  remove: removeFeatureFlagOverrideContract,
  clearAll: clearAllFeatureFlagOverridesContract,
};

// Export types
export type FeatureFlagInfo = z.infer<typeof FeatureFlagInfoSchema>;
export type ListFeatureFlagsRequest = z.infer<
  typeof ListFeatureFlagsRequestSchema
>;
export type ListFeatureFlagsResponse = z.infer<
  typeof ListFeatureFlagsResponseSchema
>;
export type SetFeatureFlagOverrideRequest = z.infer<
  typeof SetFeatureFlagOverrideRequestSchema
>;
export type SetFeatureFlagOverrideResponse = z.infer<
  typeof SetFeatureFlagOverrideResponseSchema
>;
export type RemoveFeatureFlagOverrideRequest = z.infer<
  typeof RemoveFeatureFlagOverrideRequestSchema
>;
export type RemoveFeatureFlagOverrideResponse = z.infer<
  typeof RemoveFeatureFlagOverrideResponseSchema
>;
export type ClearAllFeatureFlagOverridesRequest = z.infer<
  typeof ClearAllFeatureFlagOverridesRequestSchema
>;
export type ClearAllFeatureFlagOverridesResponse = z.infer<
  typeof ClearAllFeatureFlagOverridesResponseSchema
>;
